import * as moment from 'moment';
import {EtaEmitter} from './eta-emitter.enum';
import {Carrier} from '../../user-dashboard/shared/carrier.model';
import { LocalLocationType } from '../../local-loads/shared/local-location-type';

export class EtaReport {
  public id: string;
  public deliveryNumber: string;

  public recordedAt: moment.Moment;
  public emitter: EtaEmitter;
  public emittedLatitude: number;
  public emittedLongitude: number
  public eta: moment.Moment;
  public etaRangeStart: moment.Moment;
  public etaRangeEnd: moment.Moment;
  public originLatitude: number;
  public originLongitude: number;
  public originGlid: string;
  public originLocationType: LocalLocationType;
  public targetLatitude: number;
  public targetLongitude: number;
  public targetGlid: string;
  public targetLocationType: LocalLocationType;
  public targetTimezone: string;
  public carrier: Carrier;

  static fromDto(p): EtaReport {
    const eta = new EtaReport();
    eta.id = p.id;
    eta.deliveryNumber = p.delivery_number;
    eta.recordedAt = moment(p.recorded_at);
    eta.emitter = p.emitter;
    eta.emittedLatitude = p.emitted_latitude;
    eta.emittedLongitude = p.emitted_longitude;
    eta.eta = moment(p.eta);
    eta.etaRangeStart = moment(p.eta_range_start);
    eta.etaRangeEnd = moment(p.eta_range_end);
    eta.originLatitude = p.origin_latitude;
    eta.originLongitude = p.origin_longitude;
    eta.originGlid = p.origin_glid;
    eta.originLocationType = p.origin_location_type;
    eta.targetLatitude = p.target_latitude;
    eta.targetLongitude = p.target_longitude;
    eta.targetGlid = p.target_glid;
    eta.targetLocationType = p.target_location_type;
    eta.targetTimezone = p.target_timezone;
    eta.carrier = Carrier.fromDto(p.carrier);

    return eta;
  }
}
